import React, { useState } from 'react';
import { Send, Sparkles } from 'lucide-react';
import { motion } from 'framer-motion';
interface PromptBoxProps {
  placeholder?: string;
  onSubmit?: (prompt: string) => void;
}
export function PromptBox({
  placeholder = 'Describe lo que quieres generar...',
  onSubmit
}: PromptBoxProps) {
  const [prompt, setPrompt] = useState('');
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (prompt.trim() && onSubmit) {
      onSubmit(prompt);
      setPrompt('');
    }
  };
  return <motion.div initial={{
    opacity: 0,
    y: 20
  }} animate={{
    opacity: 1,
    y: 0
  }} className="w-full" data-id="element-90">
      <form onSubmit={handleSubmit} className="relative" data-id="element-91">
        <div className="bg-white rounded-2xl shadow-lg border border-gray-100 p-4" data-id="element-92">
          <div className="flex items-start gap-3" data-id="element-93">
            <div className="p-2 bg-gradient-to-br from-orange-500 to-pink-500 rounded-xl text-white" data-id="element-94">
              <Sparkles className="w-5 h-5" data-id="element-95" />
            </div>
            <textarea value={prompt} onChange={e => setPrompt(e.target.value)} placeholder={placeholder} className="flex-1 resize-none border-none outline-none text-gray-900 placeholder-gray-400 text-sm min-h-[80px]" rows={3} data-id="element-96" />
          </div>
          <div className="flex items-center justify-between mt-4 pt-4 border-t border-gray-100" data-id="element-97">
            <div className="flex items-center gap-2 text-xs text-gray-500" data-id="element-98">
              <span data-id="element-99">Presiona Enter para enviar</span>
            </div>
            <button type="submit" disabled={!prompt.trim()} className="flex items-center gap-2 px-4 py-2 bg-gradient-to-r from-orange-500 to-pink-500 text-white rounded-xl font-medium text-sm hover:opacity-90 transition-all disabled:opacity-50 disabled:cursor-not-allowed" data-id="element-100">
              <Send className="w-4 h-4" data-id="element-101" />
              Generar
            </button>
          </div>
        </div>
      </form>
    </motion.div>;
}